import withRoot from "./modules/withRoot";
// --- Post bootstrap -----
import React, { useEffect } from "react";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import { Link as RouterLink } from "react-router-dom";
import Typography from "./modules/components/Typography";
import FAQAccordion from "./modules/components/FAQAccordion";
import SupportHero from "./modules/views/SupportHero";
import CommonIssues from "./modules/views/CommonIssues";
import AppFooter from "./modules/views/AppFooter";
import ReactGA from "react-ga";

const TRACKING_ID = "UA-211546357-1";
ReactGA.initialize(TRACKING_ID);

const faqItems = [
  {
    question: "What's the difference between Dubslack and Dubstatus?",
    answer:
      "Dubslack is the smartphone app you use to manage your status. Dubstatus is the Slack app that Dubslack connects through, and it's the name you'll see on Slack's authorization screen when you connect a workspace.",
  },
  {
    question: "What information should I include when I email support?",
    answer:
      "Please include your device type (iOS or Android), the Dubslack app version, and a short description of what happened, including any error message you saw.",
  },
    {
        question: "What permissions does Dubslack request?",
        answer:
            "Dubslack only requests the Slack permissions needed to read and update your status, presence, and basic profile information in each workspace you connect. It does not request access to your messages or files.",
    },
  {
    question: "What personal data do you collect?",
    answer: (
      <React.Fragment>
        None. See our{" "}
        <Link component={RouterLink} to="/privacy-policy">
          Privacy page
        </Link>{" "}
        for details.
      </React.Fragment>
    ),
  },
    {
        question: "How do I delete my account data?",
        answer:
            "In the Dubslack app, go to Settings, expand Delete Account Data, and delete Statuses and Accounts.",
    },
  {
    question: "Does Dubslack store my Slack password?",
    answer:
      "No. Dubslack never sees or stores your Slack password. Every workspace connection is authorized through Slack's own OAuth sign-in screen.",
  },
  {
    question: "Why can't I connect my workspace?",
    answer:
      "Some Slack workspaces require approval from a Workspace Owner or Administrator before a new app can be installed. Ask your Workspace Owner or Administrator to approve or install Dubslack.",
  },
];

function Support() {
  useEffect(() => {
    ReactGA.event({
      category: "Page Load",
      action: "Support Page",
    });
  }, []);

  return (
    <React.Fragment>
      <SupportHero />
      <CommonIssues />

      <Container>
        <Box mt={2} mb={10}>
          <Typography variant="h4" marked="center" align="center" gutterBottom>
            Frequently Asked Questions
          </Typography>
          <Box mt={4}>
            <FAQAccordion items={faqItems} />
          </Box>
        </Box>
      </Container>

      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(Support);
